import { post } from './client'
import type {
  AgreementResponses,
  CartResponse,
  ContactInfo,
  LineItem,
  RecipientInfo,
  SetLineItemData,
  SurveyResponses
} from '#root/types/cart'

export {
  fnLoadCart,
  fnLoadCheckout,
  fnLoadInformation,
  fnSetLineItem,
  fnSubmitCheckout,
  fnSubmitInformation,
  fnUpdatePurchaser,
  fnUpdateRecipients
}

/** Stripe checkout session metadata (key/value strings). */
type StripeMetadataParam = Record<string, string>

async function fnLoadCart(
  testMode: boolean,
  cartId: string | null,
  cartToken: string | null
): Promise<CartResponse> {
  return post({
    method: 'LoadCart',
    args: [testMode, cartId, cartToken]
  }) as Promise<CartResponse>
}

async function fnLoadCheckout(
  testMode: boolean,
  cartId: string | null,
  cartToken: string | null
): Promise<CartResponse> {
  return post({
    method: 'LoadCheckout',
    args: [testMode, cartId, cartToken]
  }) as Promise<CartResponse>
}

async function fnLoadInformation(
  testMode: boolean,
  cartId: string | null,
  cartToken: string | null
): Promise<CartResponse> {
  return post({
    method: 'LoadInformation',
    args: [testMode, cartId, cartToken]
  }) as Promise<CartResponse>
}

async function fnSetLineItem(
  testMode: boolean,
  cartId: string | null,
  cartToken: string | null,
  sku: string,
  data: SetLineItemData
): Promise<CartResponse> {
  return post({
    method: 'SetLineItem',
    args: [testMode, cartId, cartToken, sku, data]
  }) as Promise<CartResponse>
}

async function fnSubmitCheckout(
  testMode: boolean,
  cartId: string | null,
  cartToken: string | null,
  email: string,
  lineItems: LineItem[],
  distinctId: string | null,
  location: string,
  metadata: StripeMetadataParam,
  payment: boolean
): Promise<CartResponse> {
  return post({
    method: 'SubmitCheckout',
    args: [
      testMode,
      cartId,
      cartToken,
      email,
      lineItems,
      distinctId,
      location,
      metadata,
      payment
    ]
  }) as Promise<CartResponse>
}

async function fnSubmitInformation(
  testMode: boolean,
  cartId: string | null,
  cartToken: string | null,
  contactInfo: ContactInfo,
  agreementResponses: AgreementResponses,
  surveyResponses: SurveyResponses,
  lineItems: LineItem[]
): Promise<CartResponse> {
  return post({
    method: 'SubmitInformation',
    args: [
      testMode,
      cartId,
      cartToken,
      contactInfo,
      agreementResponses,
      surveyResponses,
      lineItems
    ]
  }) as Promise<CartResponse>
}

async function fnUpdatePurchaser(
  testMode: boolean,
  cartId: string,
  cartToken: string,
  contactInfo: ContactInfo,
  agreementResponses: AgreementResponses,
  surveyResponses: SurveyResponses
): Promise<CartResponse> {
  return post({
    method: 'UpdatePurchaser',
    args: [
      testMode,
      cartId,
      cartToken,
      contactInfo,
      agreementResponses,
      surveyResponses
    ]
  }) as Promise<CartResponse>
}

async function fnUpdateRecipients(
  testMode: boolean,
  cartId: string,
  cartToken: string,
  sku: string,
  recipientInfos: RecipientInfo[]
): Promise<CartResponse> {
  return post({
    method: 'UpdateRecipients',
    args: [testMode, cartId, cartToken, sku, recipientInfos]
  }) as Promise<CartResponse>
}
